import { SistemaWeb } from './sistema-web.enum'
import { VersaoWebJson } from './versao-web-json.interface'

export class VersaoWeb {
    sistema: SistemaWeb
    numero: number

    constructor(obj: VersaoWebJson) {
        this.sistema = obj.Tipo
        this.numero = obj.Versao
    }

    isIgualOuSuperior(numero: number) {
        return this.numero >= numero
    }
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/core/controle-versao/versao-web.ts